/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import { Button, Checkbox, Form, Row, Col, Input } from "antd";
import moment from "moment";
import TableLineIcons from "../../components/TableLineIcons";
import DateTimePicker from "../../components/DateTimePicker";
import ResponsiveTable from "../../components/ResponsiveTable";


class AccessRules extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "ACCESS_RULES";

        this.api = {
            get: "get_access_rules",
            create_edit: "create_edit_access_rules",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22626);
    }


    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        const render = t => t;
        const renderDate = t => t ? moment(t).format("DD/MM/YYYY") : "";
        const renderCB = t => (<Checkbox checked={t == 1} />)
        const renderEditCol = (t, r) => (<TableLineIcons onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, r.key, r.index) }} />)
        const { editing, editedRecord } = this.props.data[this.id];
        const onChange = (data) => { this.props.dataActions.genericDataSetEdit(this.id, data) }
        const onCancel = () => {
            if (editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id)
            else this.props.dataActions.genericDataCancelEditing(this.id)
        }
        const onSave = () => {
            this.props.dataActions.genericDataSaveEdit(this.id, this.props.user.companyCode, this.props.user.token, this.api.create_edit, this.api.get)
        }
        const renderDayName = (t, r) => {
            return this.getText(22638 + parseInt(r.day))
        }
        const renderHourFrom = (t, r) => {
            return (<DateTimePicker format="HH:mm" value={t} onChange={e => { onChange({ [r.key + 'From']: e }) }} />)
        }
        const renderHourTo = (t, r) => {
            return (<DateTimePicker format="HH:mm" value={t} onChange={e => { onChange({ [r.key + 'To']: e }) }} />)
        }

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(22626)}
                searchBox
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                columns={[
                    //'rID','rDesc','rRemarks','rValidFrom','rValidTo','rLogChanges','rIPFrom','rIPTo','rIsActive','rCreationDate','rCreationUser',
                    // 'rSunFrom','rSunTo','rMonFrom','rMonTo','rTueFrom','rTueTo','rWedFrom','rWedTo','rThrFrom','rThrTo','rFriFrom','rFriTo','rSatFrom','rSatTo'
                    { title: gt(22627), key: 'rID', dataIndex: 'rID', width: '6%', sorter: true, render: render },
                    { title: gt(22628), key: 'rDesc', dataIndex: 'rDesc', width: '15%', sorter: true, render: render },
                    { title: gt(22629), key: 'rRemarks', dataIndex: 'rRemarks', width: '27%', sorter: true, render: render },
                    { title: gt(22630), key: 'rValidFrom', dataIndex: 'rValidFrom', width: '10%', sorter: true, render: renderDate },
                    { title: gt(22631), key: 'rValidTo', dataIndex: 'rValidTo', width: '10%', sorter: true, render: renderDate },
                    { title: gt(22632), key: 'rIPFrom', dataIndex: 'rIPFrom', width: '10%', sorter: true, render: render },
                    { title: gt(22633), key: 'rIPTo', dataIndex: 'rIPTo', width: '10%', sorter: true, render: render },
                    { title: gt(22634), key: 'rIsActive', dataIndex: 'rIsActive', width: '6%', sorter: true, render: renderCB },
                    { title: gt(22635), width: '6%', render: renderEditCol },
                ]}
            />
            <GenericModal
                visible={editing > -1}
                onCancel={onCancel}
                title={gt(22636)}
                width={1200}
                footer={[
                    <Button key={"back"} onClick={onCancel} style={{ margin: 5 }}>{gt(22637)}</Button>,
                    <Button key={"create"} type="primary" onClick={onSave} style={{ margin: 5 }}>{gt(22638)}</Button>,
                ]}
            >
                <Row>
                    <Col span={8} style={{ padding: 10 }}>
                        <Form.Item label={gt(22628)}>
                            <Input value={editedRecord.rDesc} onChange={e => { onChange({ rDesc: e.target.value }) }} />
                        </Form.Item>
                        <Form.Item label={gt(22629)}>
                            <Input.TextArea rows={5} value={editedRecord.rRemarks} onChange={e => { onChange({ rRemarks: e.target.value }) }} />
                        </Form.Item>
                        <Form.Item>
                            <Checkbox checked={editedRecord.rIsActive == 1} onChange={e => { onChange({ rIsActive: e.target.checked ? '1' : '0' }) }} >
                                {gt(22634)}
                            </Checkbox>
                        </Form.Item>
                        <Button type="primary" onClick={() => { this.setState({ showLogChanges: true }) }} style={{ margin: 5 }}>{gt(22650)}</Button>
                        <GenericModal
                            visible={this.state.showLogChanges}
                            onCancel={() => { this.setState({ showLogChanges: false }) }}
                            title={gt(22651)}
                            width={800}>
                            <ResponsiveTable
                                tableOnly
                                dataSource={editedRecord.rLogChanges ? JSON.parse(editedRecord.rLogChanges) : []}
                                columns={[
                                    { title: gt(22652), key: '_datetime', dataIndex: '_datetime', width: '20%', render: t => t ? moment(t).format("DD/MM/YYYY HH:mm") : "" },
                                    { title: gt(22653), key: '_userName', dataIndex: '_userName', width: '20%', render: render },
                                    { title: gt(22654), key: '_fieldName', dataIndex: '_fieldName', width: '20%', render: render },
                                    { title: gt(22655), key: '_oldData', dataIndex: '_oldData', width: '20%', render: render },
                                    { title: gt(22656), key: '_newData', dataIndex: '_newData', width: '20%', render: render },
                                ]}
                            />
                        </GenericModal>
                    </Col>
                    <Col span={8} style={{ padding: 10 }}>
                        <Form.Item label={gt(22630)}>
                            <DateTimePicker format="DD/MM/YYYY" value={editedRecord.rValidFrom} onChange={e => { onChange({ rValidFrom: e }) }} />
                        </Form.Item>
                        <Form.Item label={gt(22631)}>
                            <DateTimePicker format="DD/MM/YYYY" value={editedRecord.rValidTo} onChange={e => { onChange({ rValidTo: e }) }} />
                        </Form.Item>
                        <Form.Item label={gt(22632)}>
                            <Input value={editedRecord.rIPFrom} onChange={e => { onChange({ rIPFrom: e.target.value }) }} />
                        </Form.Item>
                        <Form.Item label={gt(22633)}>
                            <Input value={editedRecord.rIPTo} onChange={e => { onChange({ rIPTo: e.target.value }) }} />
                        </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: 10 }}>
                        <Form.Item label={gt(22649)}>
                            <ResponsiveTable
                                tableOnly
                                pagination={false}
                                dataSource={[
                                    { key: 'rSun', day: '1', from: editedRecord.rSunFrom, to: editedRecord.rSunTo },
                                    { key: 'rMon', day: '2', from: editedRecord.rMonFrom, to: editedRecord.rMonTo },
                                    { key: 'rTue', day: '3', from: editedRecord.rTueFrom, to: editedRecord.rTueTo },
                                    { key: 'rWed', day: '4', from: editedRecord.rWedFrom, to: editedRecord.rWedTo },
                                    { key: 'rThr', day: '5', from: editedRecord.rThrFrom, to: editedRecord.rThrTo },
                                    { key: 'rFri', day: '6', from: editedRecord.rFriFrom, to: editedRecord.rFriTo },
                                    { key: 'rSat', day: '7', from: editedRecord.rSatFrom, to: editedRecord.rSatTo },
                                ]}
                                columns={[
                                    { title: gt(22646), key: 'day', dataIndex: 'day', width: '40%', render: renderDayName },
                                    { title: gt(22647), key: 'from', dataIndex: 'from', width: '30%', render: renderHourFrom },
                                    { title: gt(22648), key: 'to', dataIndex: 'to', width: '30%', render: renderHourTo },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </GenericModal>
        </div>)
    }

}

export default AccessRules;